// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForwardOutlinedSvg from "@fishx/icons-svg/es/asn/ForwardOutlined";
import FishxIcon from '../components/FishxIcon';

var ForwardOutlined = function ForwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ForwardOutlinedSvg
  }));
};

ForwardOutlined.displayName = 'ForwardOutlined';
export default React.forwardRef(ForwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ForwardOutlined.js
// module id = 2832
// module chunks = 0